export const formatMoneyAmount = (value) => {
  if (value == null) return '0';
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return '0';

  return Number(numericValue.toFixed(2)).toString();
};
